import Image from 'next/image';
import Link from 'next/link';

import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';
import { BOOKING_PORTAL_URL } from '@/services/connections.service';

const RadialBubbleBackground = () => (
  <>
    <div className='pointer-events-none absolute -top-32 -left-32 h-[400px] w-[400px] rounded-full bg-radial-pink-soft blur-2xl' />
    <div className='pointer-events-none absolute -bottom-40 left-1/3 h-[500px] w-[500px] rounded-full bg-radial-rose-soft blur-2xl' />
  </>
);

const EnterpriseBanner = () => {
  const [isMobile] = useIsMobile();
  return (
    <section className='relative w-full overflow-hidden mb-10 bg-[#F7F4F5]'>
      <RadialBubbleBackground />

      <div className='relative z-10 mx-auto max-w-full'>
        <div className='grid grid-cols-1 lg:grid-cols-2 items-center md:gap-12'>
          <div className='text-center lg:text-left justify-self-center p-5'>
            <div className='text-[28px] sm:text-[28px] lg:text-[48px] font-bold leading-tight tracking-wide font-Montserrat text-stroke-thin md:text-stroke-normal'>
              <span className='block text-black'>ENTERPRISE</span>
              <span className='block bg-control bg-clip-text text-transparent'>
                EVENT MANAGEMENT
              </span>
              <span className='block text-black'>PLATFORM</span>
            </div>

            <div className='mt-3 md:mt-6 text-base md:text-lg sm:text-base font-medium text-slate-600 max-w-xl mx-auto lg:mx-0 leading-relaxed font-Montserrat'>
              Plan, launch, and measure unforgettable events with the
              world&apos;s most powerful software, delivered by the
              region&apos;s best on-ground team.
            </div>

            <div className='mt-4 md:mt-8 flex justify-center lg:justify-start'>
              <Link
                href={`${BOOKING_PORTAL_URL}/pages/tech-solution-services`}
                className='font-google-basic tracking-widest inline-flex items-center gap-3 md:gap-12 rounded-full bg-control px-4 py-2 md:px-8 md:py-4 text-white font-semibold text-sm md:text-lg shadow-lg transition'
                target='_blank'
                rel='noreferrer'
              >
                GET STARTED
                <div className='self-center ml-2'>
                  <Image
                    alt='arrow right'
                    height={isMobile ? 8 : 12}
                    width={isMobile ? 12 : 16}
                    src={`${staticMediaStoreBaseURL}/icons/rightwhite.svg`}
                    style={{
                      width: isMobile ? '12px' : '16px',
                      height: isMobile ? '8px' : '12px',
                      objectFit: 'contain'
                    }}
                  />
                </div>
              </Link>
            </div>
          </div>

          <div className='relative flex justify-center lg:justify-end'>
            <div className='hidden lg:block'>
              <Image
                alt='Enterprise Event Management Platform'
                height={700}
                priority={true}
                src={`${staticMediaStoreBaseURL}/enterprise-event-management/banner-desktop.png`}
                width={700}
              />
            </div>

            <div className='block lg:hidden mt-5'>
              <Image
                alt='Enterprise Event Management Platform'
                className='w-full max-w-md mx-auto h-auto'
                height={800}
                priority={true}
                src={`${staticMediaStoreBaseURL}/enterprise-event-management/banner-mobile.png`}
                width={500}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseBanner;
